import { ChartBinSize, ChartDefinition, ChartKey, ChartQueryParam, ChartRendererType, ChartTimerName, ChartTimerStatus } from '@frontend/chart/types';
import { Application } from '@frontend/functionality/types';

import { TRANSACTION_TIMERS_VOLUME_CHART_ENDPOINT } from '../../transaction-chart-endpoints';

export const PUDO_TRANSACTION_TIMER_DROP_OFF_PENDING_WAITING_DAYS_STACKED_BAR_CHART_DEFINITION: ChartDefinition = {
    key: ChartKey.PUDO_TRANSACTION_TIMER_DROP_OFF_PENDING_WAITING_DAYS_STACKED_BAR,
    chartType: ChartRendererType.BAR,
    endpoint: TRANSACTION_TIMERS_VOLUME_CHART_ENDPOINT,
    filters: [
        { key: ChartQueryParam.APPLICATION, value: Application.PUDO },
        { key: ChartQueryParam.NAME, value: ChartTimerName.TRANSACTION_DROP_OFF_PENDING },
        { key: ChartQueryParam.STATUS, value: ChartTimerStatus.STARTED },
        { key: ChartQueryParam.BIN_SIZE, value: ChartBinSize.DAY }
    ]
};
